<template>
  <div class="app-empty-state" :class="[variantClass, { 'empty-compact': compact }]">
    <!-- Círculo do Ícone -->
    <div class="empty-state-icon-circle" :style="circleStyle">
      <slot name="icon">
        <AppIcon
          :name="icon"
          :size="iconSize"
          :color="resolvedIconColor"
        />
      </slot>
    </div>

    <!-- Título Principal -->
    <slot name="title">
      <h6 class="empty-state-title">{{ title }}</h6>
    </slot>

    <!-- Descrição / Subtítulo -->
    <slot name="description">
      <p v-if="description" class="empty-state-desc">{{ description }}</p>
    </slot>

    <!-- Slot de Ações Opcionais (ex: Botão Limpar Filtros, Criar Registro) -->
    <div v-if="$slots.action" class="empty-state-action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppEmptyState",
  props: {
    icon: {
      type: String,
      default: "inbox"
    },
    iconSize: {
      type: Number,
      default: 26
    },
    iconColor: {
      type: String,
      default: ""
    },
    iconBg: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "default" // 'default' | 'success' | 'pendente' | 'danger' | 'warning' | 'info'
    },
    title: {
      type: String,
      default: "Nenhum registro encontrado"
    },
    description: {
      type: String,
      default: ""
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    variantClass() {
      return "variant-" + (this.variant || "default");
    },
    resolvedIconColor() {
      if (this.iconColor) return this.iconColor;
      if (this.variant === "success" || this.variant === "pendente") return "#00bba2";
      if (this.variant === "info" || this.variant === "sucesso") return "#0284c7";
      if (this.variant === "danger" || this.variant === "falha") return "#e11d48";
      if (this.variant === "warning") return "#d97706";
      return "#64748b";
    },
    circleStyle() {
      const s = {};
      if (this.iconBg) s.backgroundColor = this.iconBg;
      return s;
    }
  }
};
</script>

<style scoped>
.app-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 36px 20px;
  margin: 12px 8px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  min-height: 200px;
  width: calc(100% - 16px);
  box-sizing: border-box;
}

.app-empty-state.empty-compact {
  padding: 20px 14px;
  min-height: 140px;
  margin: 6px 4px;
}

.empty-state-icon-circle {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  transition: transform 0.2s ease;
}

.empty-compact .empty-state-icon-circle {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}

/* Variantes de cores */
.variant-default .empty-state-icon-circle {
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.variant-pendente .empty-state-icon-circle,
.variant-success .empty-state-icon-circle {
  background: #f0fdf4;
  color: #00bba2;
  border: 1px solid #bbf7d0;
}

.variant-info .empty-state-icon-circle,
.variant-sucesso .empty-state-icon-circle {
  background: #f0f9ff;
  color: #0284c7;
  border: 1px solid #bae6fd;
}

.variant-danger .empty-state-icon-circle,
.variant-falha .empty-state-icon-circle {
  background: #fff1f2;
  color: #e11d48;
  border: 1px solid #fecdd3;
}

.variant-warning .empty-state-icon-circle {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid #fde68a;
}

.empty-state-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px 0;
  letter-spacing: -0.01em;
}

.empty-compact .empty-state-title {
  font-size: 13px;
  margin-bottom: 4px;
}

.empty-state-desc {
  font-size: 12px;
  color: #64748b;
  max-width: 280px;
  margin: 0;
  line-height: 1.45;
}

.empty-compact .empty-state-desc {
  font-size: 11px;
  max-width: 240px;
}

.empty-state-action {
  margin-top: 14px;
}
</style>
